var applyDiscount = function() {
  /* Read the Query String value from the URL */    
  
  var urlParams;
  (window.onpopstate = function () {
    var match,
        pl     = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query  = window.location.search.substring(1);

    urlParams = {};
    while (match = search.exec(query))
      urlParams[decode(match[1])] = decode(match[2]);
  })();

  /* If the value of the hidden discount input field is blank, undefined or null then set the contents of localstorage discount to be the result of our Query String function above */    
  if ($("#discount_input").val() == ('' || undefined || null || 'undefined') && urlParams["discount"]) {
    /* Set sessionStorage variable "discount" to the result of our Query string function above */
    sessionStorage.setItem("discount", urlParams["discount"]);
  }

  /* If the value in our hidden input field doesn’t match the result of our Query String function above then clear the current sessionStorage value for "discount" and replace it with the new one */
  /* Link: http://stackoverflow.com/q/19844750 */
  else if ($("#discount_input").val() != urlParams["discount"] && urlParams["discount"] ) {
    sessionStorage.removeItem("discount");
    sessionStorage.setItem("discount", urlParams["discount"]);
  }
  
  
  
  /* If the value of the hidden discount input field is blank, undefined or null then set the contents of localstorage discount to be the result of our Query String function above */    
  if ($("#discount_percentage").val() == ('' || undefined || null || 'undefined') && urlParams["discpercentageount"]) {
    /* Set sessionStorage variable "discount" to the result of our Query string function above */
    sessionStorage.setItem("percentage", urlParams["percentage"]);
  }

  /* If the value in our hidden input field doesn’t match the result of our Query String function above then clear the current sessionStorage value for "discount" and replace it with the new one */
  /* Link: http://stackoverflow.com/q/19844750 */
  else if ($("#discount_percentage").val() != urlParams["percentage"] && urlParams["percentage"]) {
    sessionStorage.removeItem("percentage");
    sessionStorage.setItem("percentage", urlParams["percentage"]);
  }
  
  
  if (urlParams["percentage"]) {
  	console.log(urlParams["percentage"]);
    var get_percentage = urlParams["percentage"];
    setTimeout(function(){
      var dis_bar = $('#DiscountBar').text();
      dis_bar = dis_bar.replace('(number)', get_percentage);
      $('#DiscountBar').text(dis_bar);
    }, 1200);
  } else {
      if ($("#discount_percentage").val() == ('' || undefined || null || 'undefined')) {
        console.log("NO DISCOUNT FOUND");
      }
      else {
      	setTimeout(function(){
          var dis_bar = $('#DiscountBar').text();
          var get_percentage = $("#discount_percentage").val();
          dis_bar = dis_bar.replace('(number)', get_percentage);
          $('#DiscountBar').text(dis_bar);
        }, 1200);
      }
  }
  
  if (sessionStorage.getItem("discount")) {
    if (sessionStorage.getItem("discount").length != 0) {
      setTimeout(function() {
        $('#DiscountBar').addClass('visible-bar');
        $('body').addClass('discount--active');
      }, 1000);
    };	
  }
  
  setTimeout(function(){
    if ($(window).width() < 769) {
  			$("#PageContainer").css({"padding-top": $("#header").height() + $(".top-bar").height() + $(".promo-bar").height() });
  		}
  }, 2000);
   
};


document.addEventListener('DOMContentLoaded', function(e){
  applyDiscount(); 
});